
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { mapActions, mapGetters } from 'vuex';

import { MAX_WORKFLOW_NAME_LENGTH, PLACEHOLDER_EMPTY_WORKFLOW_ID } from '@/constants';
import { workflowHelpers } from '@/components/mixins/workflowHelpers';
import { titleChange } from '@/components/mixins/titleChange';
import { showMessage } from '@/components/mixins/showMessage';
import WebStorage from '@/common/WebStorage';
import AliareInput from '@/components/AliareInput.vue';
import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import InfoBox from '@/components/InfoBox.vue';
import TagsDropdown from '@/components/TagsDropdown.vue';
import Modal from './Modal.vue';

export default mixins(showMessage, workflowHelpers, titleChange).extend({
	components: {
		TagsDropdown,
		Modal,
		AliareInput,
		ModalButtonSuccess,
		InfoBox,
	},
	name: 'DuplicateWorkflow',
	props: ['modalName', 'isActive'],
	data() {
		return {
			selectedProject: '',
			dataProject: '',
			name: '',
			isSaving: false,
			modalBus: new Vue(),
			dropdownBus: new Vue(),
			isFocused: false,
			nameWorkflow: '',
			MAX_WORKFLOW_NAME_LENGTH,
		};
	},
	async mounted() {
		this.getProjects();
	},
	computed: {
		workflowVersionData() {
			return this.$store.getters.getWorkflowVersionData;
		},
		workspace() {
			return this.$store.getters.workspace;
		},
	},
	watch: {
	},
	methods: {
		onSelect(type: string) {
			this.selectedProject =  type;
		},
		async getProjects() {
			const payload = {
				size: 9999,
			};
			await this.restApi().getProjects(this.workspace.id, payload).then((response) => {
				this.dataProject = response;
			});
		},
		onFocus() {
			this.isFocused = !this.isFocused;
		},

		async saveCopy() {
			try {
				let	data = this.workflowVersionData;

				let workflowVersion = {
					projetoId: this.selectedProject.id,
					nome: this.nameWorkflow,
					workflowData: data,
				}

				const workflowData = await this.restApi().createNewWorkflow(this.workspace.id, workflowVersion);

				this.$store.commit('activeAlert', {
					message: this.$locale.baseText('VersionHistoryDetails.saveCopySuccess', { interpolate: {savedWorkflowName: workflowData.nome, savedProjectName: this.selectedProject.nome, savedAccountName: WebStorage.getItem("accountName")} }),
				});

				this.modalBus.$emit('close');

				this.openWorkflow(workflowData.id);
			} catch(e) {
				this.$store.commit('activeAlert', {
					message: e?.notifications[0],
					status: 'error'
				});
			}
		},

		async openWorkflow(workflowId: string) {
			this.$titleSet(this.workflowName, "IDLE");
			// Change to other workflow
			this.$router.push({
				name: "NodeViewExisting",
				params: { name: workflowId },
			});
		},


		closeDialog(): void {
			this.modalBus.$emit('close');
		},
	},
	beforeDestroy() {
		this.$store.commit('setWorkflowId', PLACEHOLDER_EMPTY_WORKFLOW_ID);
	},
});
